module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }, [_c('h2', {
    staticClass: "listhead"
  }, [_vm._v("Lists of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "listsubhead"
  }, [_vm._v("Maps")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Regional Maps")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_vm._v("Key")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("1.")]), _vm._v("The Jazīra")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("2.")]), _vm._v("The Upper Euphrates")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("3.")]), _vm._v("The Middle Euphrates")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("4.")]), _vm._v("Cilicia and Western Syria")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("5.")]), _vm._v("Western Syria and Northern Lebanon")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("6.")]), _vm._v("Lebanon and Northern Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("7.")]), _vm._v("Southern Palestine")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("8.")]), _vm._v("Sinai")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num"
  }, [_vm._v("9.")]), _vm._v("Egypt")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('span', {
    staticClass: "hang_num1"
  }, [_vm._v("10.")]), _vm._v("Cyprus")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The First Crusade")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("The Frankish principalities at about their largest")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("‘Desert castles’")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Region around the Hula Valley")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Jabal ʿAwf")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Reynald of Châtillon’s Arabian campaigns, 1181, 1182–83")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Templar towers on the road from Jaffa to Jericho")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Castles around Ascalon")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Strongholds slighted by Saladin (1190–91) and al-Muʿaẓẓam ʿĪsā(1218–19)")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }, [_vm._v("Strongholds preserved and slighted by the ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-23",
      "id": "gl_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mamlūks")]), _vm._v(", 1260–91")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Major battle")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Baybars’ campaign against Safed, 1266")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Saladin’s campaign in Palestine, 1187")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Saladin’s campaign in western Syria, 1188")]), _vm._v(" "), _c('p', {
    staticClass: "listsubhead"
  }, [_vm._v("Plans")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("‘Desert castles’\t")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Damascus, citadel\t")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Bosra, theatre-citadel\t")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Kerak (with topography)\t")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Crac des Chevaliers and Jacob’s Ford in the twelfth century")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Bānyās (with topography) ")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_vm._v("Tyre (with topography)")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Jerusalem, siege of 1099, final deployments (with topography)")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Arsūf (with topography) ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Antioch, town defences and siege forts of the First Crusade (with topography)")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("ʿAtlit, outer wall embrasure")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("ʿAjlūn, level 2 with exposed sections of level 1 ")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }, [_vm._v("Tortosa, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-21",
      "id": "gl_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("keep")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Caesarea, defences improved by Louis IX and earlier Roman wall (with topography)")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Sidon, sea castle")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Bent entrances")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Cairo, Bāb al-Barqiyya ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Aleppo, citadel gatehouse")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Crac des Chevaliers (with topography)")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Saone (with topography)")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Twelfth-century "), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-31",
      "id": "gl_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("quadriburgium")]), _vm._v(" enclosure castles")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Belvoir")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Cairo, citadel")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Cairo, citadel towers Burj al-Ramla and Burj al-Ḥaddād ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Ṣubayba")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montfort")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("ʿAtlit, second level of the outer defences, first level of the inner defences")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Mamlūk towers with central pillars \t")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Ṣubayba, outer southwestern tower\t")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Edwardian castles\t")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Acre, siege of 1291\t")]), _vm._v(" "), _c('p', {
    staticClass: "listsubhead"
  }, [_vm._v("Images")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Antioch, town walls as seen in the eighteenth century")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Crac des Chevaliers")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Apamea")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Qaṣr al-Ḥayr al-Sharqī, entrance of the smaller enclosure ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montreal")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Beaufort")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Caesarea")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("ʿAjlūn")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("ʿAjlūn and region to the immediate south ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Ṣubayba")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Aleppo, citadel gatehouse")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Castellum Regis, in the centre of Miʿilya")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montfort")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_vm._v("Ṣubayba, from the east")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Le Destroit")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Kerak")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Jacob’s Ford, northeastern corner of the castle and the river to the right")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Margat")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Qalʿat Jaʿbar")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montfort, mine in the outer southwestern tower")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montfort, mine in the southern wall of the upper ward")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Siege tower")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }, [_vm._v("Counterweight ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-39",
      "id": "gl_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("trebuchet")]), _vm._v(", Cardiff castle")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Traction trebuchet, Caerphilly castle")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Al-Ṭarsūsī’s Persian trebuchet ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Arsūf, outer southern tower, featuring artillery damage inflicted during the siege of 1265 before the tower was destroyed by the Mamlūk sappers")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Arsūf, artillery projectiles from the siege of 1265")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Maṣyāf")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Al-Ḥabis, from the great temple of Petra")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Subayba, reservoir")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Saone, cistern")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Crac des Chevaliers, western end of the outer southern defences")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Ṣubayba,"), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-5",
      "id": "gl_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" casemates")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-14",
      "id": "gl_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("embrasure")]), _vm._v("s of the southern rounded tower")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Belvoir, embrasures of one of the inner towers")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Belvoir, exterior of one of the embrasures of the inner enclosure")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Saone, embrasures along the outer eastern wall")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Kerak, line of casemates built by the Mamlūks along the outer western wall")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Chastel Neuf, "), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-16",
      "id": "gl_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fosse")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Kerak, northern fosse")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Saone, eastern fosse")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Caesarea, "), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-37",
      "id": "gl_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("talus")]), _vm._v(" around the town defences")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Shayzar, northern "), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-18",
      "id": "gl_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("glacis")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Kerak, eastern glacis")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("ʿAjlūn, slot "), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-22",
      "id": "gl_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("machicolation")]), _vm._v(" over the inner gate of the outer gateway ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montfort, machicolation over the inner northwestern gate")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montfort, looking down through the machicolation over the outer northwestern gate")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Crac des Chevaliers, Mamlūk box machicolations ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Bānyās, through column ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Arsūf, through column ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Caesarea, outer gate of the eastern gateway, featuring a slot machicolation, "), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-29",
      "id": "gl_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("portcullis")]), _vm._v(" groove, lower socket for a leaf door and pocket in the wall for a locking bar")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("ʿAjlūn, outer gate and barbican ")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-10"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_vm._v("ʿAjlūn, inside the outer barbican ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Safed, southwestern gate and barbican")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "VPS-10"
    }
  }, [_vm._v("Caesarea, closed ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/017_Glossary#gl-30",
      "id": "gl_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("postern")]), _vm._v(" in the northern town wall")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Belvoir, staircase to the postern in the western mural tower")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Belvoir, postern in the outer southwestern tower")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Ṣubayba, postern in tower 11")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Chastel Blanc")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Belvoir")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Crac des Chevaliers, eastern side of the outwork from the outer wall")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Al-Raḥba")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montreal, inscription on the north tower")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Le Destroit, with ʿAtlit in the background")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Ṣubayba, topmost northeastern shooting chamber of the outer southwestern tower")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Montreal, from the west")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Ṣubayba, upper castle from the outer southwestern tower")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Fort Saint-André (Villeneuve-lès-Avignon), main gate ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Chepstow, Marten’s Tower and straight eastern entrance")]), _vm._v(" "), _c('p', {
    staticClass: "listsubhead"
  }, [_vm._v("Graphs and Tables")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Use of siege towers, 1097–1200 ")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Use of Frankish siege towers by decade")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Maritime forces at twelfth-century Frankish sieges of coastal Mediterranean towns")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Terms of surrender after the battle of Hattin")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Belligerents of sieges")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Distribution of sieges, before and after Hattin and Saladin’s death")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Sieges against coreligionists")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Length of sieges")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Distribution of twelfth-century sieges")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Distribution of thirteenth-century sieges")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Length and success rates of sieges by period")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696b4884","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/005_List_of_Illustrations.vue
// module id = 69
// module chunks = 0